import globalStyles from '../globals.module.css';

const SmallLoadingAlt = () => {
    return (
        <div className={globalStyles.smallLoadingContainerAlternate}>
            <div className={globalStyles.smallSpinner}></div>
        </div>
    );
};

export default SmallLoadingAlt;